import {IconButton, Tooltip, Typography} from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';
import {FC} from 'react';

import {STYLES} from './constants';

interface Props {
  title: string;
  onClick: () => void;
}

export const EditButton: FC<Props> = ({title, onClick}) => {
  return (
    <Tooltip
      title={
        <Typography component="div" variant="subtitle2">
          {title}
        </Typography>
      }
    >
      <IconButton onClick={onClick} sx={STYLES.iconButton}>
        <CreateIcon />
      </IconButton>
    </Tooltip>
  );
};
